import React from 'react'
import ReactDOM from 'react-dom'
import momentInit from 'lib/momentInit'
import { Provider } from 'react-redux'
import { addLocaleData, IntlProvider } from 'react-intl'
import en from 'react-intl/locale-data/en'
import pl from 'react-intl/locale-data/pl'
import de from 'react-intl/locale-data/de'
import createSagaMiddleware from 'redux-saga'
import Bus from 'lib/Bus'
import onError from 'lib/saga/onError'
import keepAlive from 'lib/saga/keepAlive'

import createStore from 'shift-book-notifications/store'
import ShiftBookNotifications from 'shift-book-notifications/ShiftBookNotifications'
import { setToken } from 'shift-book-notifications/actions'
import rootSaga from 'shift-book-notifications/saga'

const { timezone, locale, messages } = window

momentInit()
addLocaleData([...en, ...pl, ...de])

const initialState = { config: { locale, timezone } }
const sagaMiddleware = createSagaMiddleware({ onError })
let store = createStore(initialState, [sagaMiddleware])
let saga

Bus.on('page:load', () => {
  const node = document.getElementById('header-shift-book-notifications')

  if (node) {
    store.dispatch(setToken(node.dataset.token))
    saga = saga || keepAlive(rootSaga, sagaMiddleware)

    ReactDOM.render(
      <IntlProvider locale={locale} messages={messages}>
        <Provider store={store}>
          <ShiftBookNotifications />
        </Provider>
      </IntlProvider>,
      node
    )
  } else if (saga) {
    saga.cancel()
    saga = undefined
  }
})
